<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="box-header">
        <span class="box-header__title">Редактирование сотрудника</span>

        <el-popconfirm
          v-if="false"
          class="confirmBtn"
          @onConfirm="deleteQuestionnaire"
          title="Вы уверены?"
          confirmButtonText="Да"
          cancelButtonText="Нет"
          confirmButtonType="danger"
          cancelButtonType="default"
        >
          <el-button
            slot="reference"
            class="box-header__button"
            :loading="loadDeleteForm"
            size="mini"
            type="danger"
          >Удалить
          </el-button>
        </el-popconfirm>
      </div>

      <el-form ref="editForm" :rules="editFormRules" :model="editForm" class="edit-form" v-loading="loading">
        <div class="edit-form__title">Основная информация о сотруднике</div>
        <el-row :gutter="16" class="edit-form__row">
          <el-col :span="8">
            <el-form-item label="Фамилия" prop="surname">
              <el-input name="surname" ref="autoFocus" placeholder="Введите фамилию" v-model="editForm.surname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Имя" prop="name">
              <el-input name="name" placeholder="Введите имя" v-model="editForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Отчество" prop="patronymic">
              <el-input name="patronymic" placeholder="Введите отчество" v-model="editForm.patronymic"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item  label="Пол" prop="gender_id">
              <el-select
                v-loading="loadingGenders"
                v-model="editForm.gender_id"
                placeholder="Укажите пол"
                class="edit-form__select"
              >
                <el-option
                  v-for="gender in genderList"
                  :key="gender.id"
                  :label="gender.title"
                  :value="gender.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Дата роджения" prop="birthday">
              <el-date-picker
                v-model="editForm.birthday"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd.MM.yyyy"
                placeholder="Укажите дату рождения"
                class="edit-form__select"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">

            <el-form-item label="Департамент" prop="patronymic" >
              <el-select
                disabled
                v-model="value2"
                multiple
                collapse-tags
                class="edit-form__select"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>

        <div class="edit-form__title">Основная информация о сотруднике</div>

        <el-row :gutter="16" class="edit-form__row">
          <el-col :span="8">
            <el-form-item label="Телефон" prop="phone">
              <el-input v-mask="'+7-###-###-##-##'"
                        placeholder="+7-xxx-xxx-xx-xx"
                        auto-complete="off"
                        name="phone"
                        v-model="editForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="E-mail" prop="email">
              <el-input name="email" placeholder="Введите email адрес" v-model="editForm.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Пароль" prop="password">
              <el-input name="password" placeholder="Введите пароль" ref="password" show-password
                        v-model="editForm.password">
                <el-tooltip content="Создать надежный пароль" slot="append">
                  <el-button @click="generatePassword" icon="el-icon-magic-stick"></el-button>
                </el-tooltip>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="edit-form__title">Какие экраны видит пользователь:</div>

        <el-form-item>
          <div v-loading="rightsLoading">
            <el-checkbox-group v-if="editForm.features" v-model="editForm.features" class="dialog__select">
              <el-checkbox-button v-for="gender in featuresList" :label="gender.value" :value="gender.value" :key="gender.value">
                {{ gender.title }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </el-form-item>

      </el-form>
      <span  class="dialog-footer">
        <el-button
          name="save"
          type="primary"
          @click="edit(true)"
          class="dialog-footer__btn"
          :loading="loadEditForm"
        >Сохранить</el-button>
        <el-button
          name="save"
          type=""
          :loading="loading"
          @click="cancel"
          class="dialog-footer__btn"
        >Отменить</el-button>
      </span>

    </el-card>

  </div>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'Worker.item',
  data () {
    return {
      worker: {},
      editForm: {
        gender: []
      },
      rights: [],
      loadData: {},
      genderList: [],
      loading: false,
      loadingGenders: false,
      questionAddModal: false,
      questionEditModal: false,
      loadEditForm: false,
      rightsLoading: false,
      loadDeleteForm: false,
      loadTable: false,
      errorLoadCard: false,
      questionnaire: {
        title: null,
        description: null
      },
      featuresList: [
        {
          title: 'Список визитов',
          value: 'doctor_inspection'
        },
        {
          title: 'Прием',
          value: 'screening_plus'
        },
        {
          title: 'Бронирование',
          value: 'appointment'
        },
        {
          title: 'Клиенты',
          value: 'users'
        },
        {
          title: 'Сервисное меню',
          value: 'service_menu'
        },
        {
          title: 'Комплексы упражнений',
          value: 'complex_exercises'
        }
      ],
      selectQuestion: null,
      error: null,
      editFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Укажите описание', trigger: 'blur' }
        ],
        gender_id: [
          { required: true, message: 'Укажите поле', trigger: 'blur' }
        ]
      },
      ///
      options: [{
        value: 'Option1',
        label: 'Физтехпарк'
      }, {
        value: 'Option2',
        label: 'Термоленд'
      }, {
        value: 'Option4',
        label: 'Адрес 2'
      }, {
        value: 'Option5',
        label: 'Адрес 3'
      }],
      value2: []
    }
  },
  activated () {
    this.loading = true
    this.loadLogic()
  },
  deactivated () {
    this.editForm = {
      gender: []
    }
    this.$refs.editForm.clearValidate()
  },
  computed: {
    getId () {
      return this.$route.params.id
    }
  },
  components: {},
  methods: {
    cancel () {
      this.$router.back()
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    generatePassword () {
      Vue.set(this.editForm, 'password', Math.random().toString(36).slice(-8))
      this.$refs.password.passwordVisible = !!1
    },
    loadLogic () {
      // this.autoFocus()
      this.loadGenders()
      this.loadWorkerData()
    },
    loadWorkerData () {
      this.loading = true
      this.$api.doctor
        .getItem(this.getId)
        .then((response) => {
          // this.worker = response.data
          this.editForm = { ...response.data, ...this.defaultData() }
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loading = false
        })
    },
    loadGenders () {
      this.loadingGenders = !!1
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data

          if (this.editForm.gender) Vue.set(this.editForm, 'gender_id', this.editForm.gender.id)
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loadingGenders = false
        })
    },
    defaultData () {
      return {
        type: '20'
      }
    },
    deleteQuestion (id, index) {
      this.loadTable = !!1

      this.$api.question
        .delete(id)
        .then(() => {
          this.loadData.questions.splice(index, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка удаления',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadTable = !!0
        })
    },
    editQuestion (question) {
      this.selectQuestion = question
      this.questionEditModal = !!1
    },
    addQuestion () {
      this.questionAddModal = !!1
    },
    edit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadEditForm = !!1
          this.$api.doctor
            .update(this.getId, this.editForm)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные обновлены'
              })
            })
            .catch((response) => {
              const attribute = response.response.data.attribute
              if (attribute) {
                console.log(response.response.data.attribute)
                console.log(response.response.data.attribute.toString())
                this.$notify.error({
                  title: 'Ошибка',
                  message: response.response.data.message ? response.response.data.attribute[0] : 'Проверьте правильность полей'
                })
              } else {
                this.$notify.error({
                  title: 'Ошибка сохранения',
                  message: response.response.data.message
                })
              }
            })
            .finally(() => {
              this.loadEditForm = !!0
            })
        }
      })
    },
    deleteQuestionnaire () {
      this.loadDeleteForm = !!1
      this.$api.questionnaire
        .delete(this.getId)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.$router.push({ name: 'cpanel.questionnaire' })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка авторизации',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadDeleteForm = !!0
        })
    },
    saveSubmit () {
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }

  &__badge {
    padding: 0;

    display: inline-block;
  }

}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}

.edit-form {
  &__title {
    margin: 0 0 6px 0;
    font-size: 15px;
    line-height: 20px;
    color: #909399;
  }

  &__row {
    margin-top: 10px;
  }

  &__select {
    width: 100%;
  }

  &__btm {
    width: 100%;
  }
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;

  &__btn{
    width: 50%;
  }
}
</style>
